import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { Provider } from "react-redux";
import { Toaster } from "sonner";
import { FeedbackButton } from "@/components/boardblend/feedback-button";
import { PostHogIdentity } from "@/components/boardblend/posthog-identity";
import { store } from "@/store/store";

export default function App({ Component, pageProps }: AppProps) {
  return (
    <Provider store={store}>
      <PostHogIdentity />
      <Component {...pageProps} />
      <FeedbackButton />
      <Toaster position="bottom-right" />
    </Provider>
  );
}
